import * as Colors from "../../../../../environment/globalStyles/administratorColors";

export const body = {
    paddingRight: "30px"
};

export const cardStyle = {
    backgroundColor: Colors.primary,
    color: "white"
};

export const container = {
    paddingTop: "20px"
};

export const errorMessage = {
    color: "red",
    textAlign: "center",
    fontWeight: "bold"
};
